import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Toast } from 'primereact/toast';
import { ProgressBar } from 'primereact/progressbar';
import '../style/topbar.css';

import { uploadVideoPhoto } from '../../../../redux/slices/uploadVideoPhotoSlice';
import PageReload from '../../PageReload/PageReload';
import {
  RootState,
  UploadProgress,
} from '../interface/UploadPhotosVideos.interface';
import {
  VIDEO_UPLOAD_STATUS,
  WINDON_RELOAD_MESSAGE,
} from '../constants/menu-items.constants';
import {
  nameOfVideo,
  uploadPhotoVideoStatus,
  UploadState,
} from '../../../ProjectManagement/Photos/interface/Photos.interface';

const PhotoVideoFileUpload = () => {
  const dispatch = useDispatch();
  const [uploadProgressList, setUploadProgressList] = useState<
    UploadProgress[]
  >([]);
  const toast = useRef<Toast>(null);
  const [showFloatingToast, setShowFloatingToast] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const { filesBlob } = useSelector(
    (state: RootState) => state.uploadVideoPhoto
  );

  const { status } = useSelector(
    (state: uploadPhotoVideoStatus) => state.uploadVideoPhoto
  );
  const { videoFileName } = useSelector(
    (state: nameOfVideo) => state.uploadVideoPhoto
  );
  const { preSignedApiResponse } = useSelector(
    (state: { uploadVideoPhoto: UploadState }) => state.uploadVideoPhoto
  );

  if (preSignedApiResponse) {
    if (
      toast.current &&
      !preSignedApiResponse?.success &&
      preSignedApiResponse?.data?.status != true
    ) {
      toast.current.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Something went wrong...',
        life: 3000,
      });
    }
  }
  const handleProgress = (fileName: string, progress: number) => {
    setUploadProgressList(prev =>
      prev?.some(file => file?.fileName === fileName)
        ? prev?.map(file =>
            file?.fileName === fileName ? { ...file, progress } : file
          )
        : [...prev, { fileName, progress }]
    );
  };

  useEffect(() => {
    if (preSignedApiResponse?.data?.status === true) {
      setShowNotification(true);
    }
  }, [preSignedApiResponse]);

  useEffect(() => {
    if (filesBlob?.length > 0) {
      setUploadProgressList([]);
      setShowFloatingToast(true);
      dispatch(
        uploadVideoPhoto({
          selectedFiles: filesBlob,
          videoFileName: videoFileName,
          onProgress: handleProgress,
        })
      );
    }
  }, [filesBlob]);
  const allComplete =
    Array.isArray(uploadProgressList) &&
    uploadProgressList?.every(f => f?.progress === 100);

  const FloatingUploadToast = () => {
    if (!showFloatingToast) return null;

    return (
      <div className="progress-alert fixed p-3">
        <div className="flex relative w-full">
          <div
            className="pi pi-times absolute right-0 mt-2 cursor-pointer"
            onClick={() => setShowFloatingToast(false)}
          ></div>
          <div className="w-full pr-3">
            <h3>
              {allComplete && uploadProgressList?.length > 0
                ? 'File uploaded successfully.'
                : 'Uploading files...'}
            </h3>

            {Array.isArray(uploadProgressList) &&
              uploadProgressList?.map(file => (
                <div className="w-full mt-2" key={file?.fileName}>
                  <div className="m-0">
                    <small className="text-xs word-break text-color">
                      {file?.fileName}
                    </small>
                  </div>
                  <ProgressBar value={file?.progress}></ProgressBar>
                </div>
              ))}
          </div>
        </div>
      </div>
    );
  };
  return (
    <div className="card flex flex-column gap-3 justify-content-center">
      <Toast ref={toast} position="top-center" />
      {showNotification && <FloatingUploadToast />}
      {status != VIDEO_UPLOAD_STATUS?.IDEAL && (
        <PageReload message={WINDON_RELOAD_MESSAGE} />
      )}
    </div>
  );
};

export default PhotoVideoFileUpload;
